export default __webpack_public_path__ + "static/media/Resoee-removebg.bc458db7.png";